module.exports = __webpack_public_path__ + "img/custom_client_seed_1_en.9165a4cf.png";